import { FC } from 'react';

export const NotSet: FC = () => <span className="patient-list__not-set">Not Set</span>;
